import { createStyles } from "antd-style";
import { spinPrefixCls, checkboxPrefixCls } from "@/base/components/index";
import { ICON_PREFIX } from "@/base/constant";

export const useCheckboxGroupListStyles = createStyles(
  ({ token, css }: any) => ({
    businessUnitList: css``,
    optionStatusItem: css`
      font-weight: 400;

      .${spinPrefixCls} {
        .${ICON_PREFIX} {
          font-size: 16px !important;
        }
      }
    `,
    checkboxGroup: css`
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;

      .${checkboxPrefixCls}-wrapper {
        display: flex;
        min-height: 72px;
        flex-direction: row-reverse;
        padding-block: 16px;
        padding-inline: 24px;
        border-radius: 4px;
        align-items: center;
        border: 1px solid ${token.ColorFigmaNeutralGrayscaleGray40};
        transition: background 0.3s;

        &:not(.${checkboxPrefixCls}-wrapper-disabled) {
          &:hover {
            background: ${token.ColorFigmaComplementaryBlue05};
          }
        }

        &.${checkboxPrefixCls}-wrapper-disabled {
          background: ${token.ColorFigmaNeutralGrayscaleGray10};
        }

        &.${checkboxPrefixCls}-wrapper-checked {
          background: ${token.ColorFigmaComplementaryBlue05};
          outline: 2px solid ${token.ColorFigmaComplementaryBlue50};
          border-color: transparent;
        }

        &:not(
            .${checkboxPrefixCls}-checked
          ).${checkboxPrefixCls}-wrapper-disabled {
          .${checkboxPrefixCls} {
            visibility: hidden;
          }
        }

        .${checkboxPrefixCls}-label {
          flex: 1;
          font-size: ${token.BodyH300FontSize};
          font-style: ${token.BodyH300LetterSpacing};
          font-weight: ${token.BodyH300FontWeight};
          line-height: ${token.BodyH300LineHeight};
        }

        .${checkboxPrefixCls}-inner {
          width: 24px;
          height: 24px;
          transition: none;

          &:after {
            width: 6px;
            height: 13px;
            top: 46%;
            inset-inline-start: 30%;
          }
        }
      }
    `,
  }),
);
